import { ITrangThaiPhuHuynhReducer } from './../../page-state-model/trang-thai-phu-huynh/ITrangThaiPhuHuynhReducer';
import { ITrangThaiPhuHuynhActionTypes } from './../../action-types/trang-thai-phu-huynh/ITrangThaiPhuHuynhActionTypes';
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";

const initialState: ITrangThaiPhuHuynhReducer = {
  status: ePageBaseStatus.is_not_initialization,
  trangThaiPhuHuynhCoSoItemResponses: [],
  trangThaiPhuHuynhs: [],
  trangThaiPhuHuynhVms: [],
  isShowEditModal: false,
};

export const TRANG_THAI_PHU_HUYNHReducer = (
  state: ITrangThaiPhuHuynhReducer = initialState,
  action: ITrangThaiPhuHuynhActionTypes
): ITrangThaiPhuHuynhReducer => {
  switch (action.type) {
    
    case "TRANG_THAI_PHU_HUYNH_LOAD_CHECKDANGKY_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "TRANG_THAI_PHU_HUYNH_LOAD_CHECKDANGKY_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiPhuHuynhCoSoItemResponses: action.payload,
      };
    case "TRANG_THAI_PHU_HUYNH_LOAD_CHECKDANGKY_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiPhuHuynhCoSoItemResponses: [],
      };
    case "TRANG_THAI_PHU_HUYNH_LOAD_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "TRANG_THAI_PHU_HUYNH_LOAD_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiPhuHuynhs: action.payload,
      };
    case "TRANG_THAI_PHU_HUYNH_LOAD_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiPhuHuynhs: [],
      };
    case "TRANG_THAI_PHU_HUYNH_LOAD_COSO_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "TRANG_THAI_PHU_HUYNH_LOAD_COSO_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiPhuHuynhs: action.payload,
      };
    case "TRANG_THAI_PHU_HUYNH_LOAD_COSO_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        trangThaiPhuHuynhs: [],
      };
    case "TRANG_THAI_PHU_HUYNH_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        editingData: action.payload,
      };
    case "TRANG_THAI_PHU_HUYNH_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "TRANG_THAI_PHU_HUYNH_SAVE_START":
      return {
        ...state,
        status: ePageBaseStatus.is_saving,
      };
    case "TRANG_THAI_PHU_HUYNH_SAVE_SUCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
        isShowEditModal: false,
      };
    case "TRANG_THAI_PHU_HUYNH_SAVE_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    case "TRANG_THAI_PHU_HUYNH_DELETE_START":
      return {
        ...state,
        status: ePageBaseStatus.is_deleting,
      };
    case "TRANG_THAI_PHU_HUYNH_DELETE_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
      };
    case "TRANG_THAI_PHU_HUYNH_DELETE_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    case "TRANG_THAI_PHU_HUYNH_UPDATE_START":
      return {
        ...state,
        status: ePageBaseStatus.is_saving,
      };
    case "TRANG_THAI_PHU_HUYNH_UPDATE_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
      };
    case "TRANG_THAI_PHU_HUYNH_UPDATE_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    default:
      return state;
  }
};